<div class="status-wrapper" [class.right-space]="!nodePathLength" *ngIf="currentProcess$ | async">
  <span *ngIf="fieldImpact">
    {{ 'GENERAL.FIELD_IMPACT_CALCULATING' | translate }}
    <span *ngIf="fieldImpact?.progress">: {{ fieldImpact?.progress }} %</span>
  </span>

  <span *ngIf="dataIntegrationProcessing">
    {{ 'GENERAL.DATA_INTEGRATION_PROCESSING' | translate }}
  </span>

  <span *ngIf="fetchMpProgress">
    {{ 'GENERAL.MP_FETCH_DP_STATUS' | translate }} {{ fetchMpProgress.mpName }}
    <span *ngIf="fetchMpProgress?.progress">[{{ fetchMpProgress?.progress }}]</span>
  </span>

  <span *ngIf="dataPopulationV3Processing">
    <span *ngIf="dataPopulationV3Progress?.progress">
      {{ dataPopulationV3Progress.progress }}{{ '%: ' }}
    </span>
    {{ dataPopulationV3Progress?.currentStep.displayName }}
  </span>
</div>
